import SubHeaderBoxGray from "../SubHeaderBoxGray";
import LinkIcon from "../../../../../assets/design-revamp-company/epr-box-table/epr_input.svg";
import EPRTable from "./Table";
import { useTranslation } from "react-i18next";
import { useUserModules } from "../../../../../components/UserModuleContext";

const EPRBox = ({ businessId, mainBusinessId, category }) => {
  const { t } = useTranslation();
  const { isModuleAccessible } = useUserModules();
  const hasERPAccess = isModuleAccessible("ERP");
  return (
    <>
      {hasERPAccess && (
        <div className="component-energy-contents">
          <SubHeaderBoxGray
            title={t("ERP_INPUT")}
            description={t("ERP_INPUT_DESC")}
            icon={LinkIcon}
          />
          <EPRTable
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={category}
          />
        </div>
      )}
    </>
  );
};

export default EPRBox;
